import classnames from 'classnames/bind'
import ButtonForCopy from 'components/button_for_copy'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './input_for_copy.module.scss'

const cx = classnames.bind(styles)

export default class InputForCopy extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: props.value
    }
  }

  handleFocus() {
    this.input.focus()
    this.input.select()
  }

  render() {
    const { buttonClassName, className, title, vertical } = this.props
    const { value } = this.state

    return (
      <div className={cx(className, { clipboard: !vertical, clipboardVertical: vertical })}>
        <input
          type="text"
          ref={ref => {
            this.input = ref
          }}
          defaultValue={value}
          className={cx({ formControl: !vertical, formControlVertical: vertical })}
          onFocus={() => this.handleFocus()}
          readOnly
        />
        <ButtonForCopy
          className={cx(buttonClassName, { button: !vertical, buttonVertical: vertical })}
          target={() => this.input}
          title={title}
        />
      </div>
    )
  }
}

InputForCopy.propTypes = {
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string.isRequired,
  vertical: PropTypes.bool
}

InputForCopy.defaultProps = {
  className: null,
  buttonClassName: null,
  title: null,
  vertical: false
}
